import {Component, OnInit} from '@angular/core';
import {ProjectService} from '../../shared/services/project.service';
import {Subscription} from 'rxjs';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {SEOService} from '../../shared/services/seo.service';
import {LoadingService} from '../../shared/services/loading.service';
import {LoadingItem} from '../../shared/interfaces/loading-item';
import {Networks} from '../../shared/models/networks.enum';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-liste-page',
  templateUrl: './liste-page.component.html',
  styleUrls: ['./liste-page.component.scss']
})
export class ListePageComponent implements OnInit {

  constructor(private _projectService: ProjectService,
              private _loadingService: LoadingService,
              private _seoService: SEOService,
              private sanitizer: DomSanitizer) { }
  serviceSubscription: Subscription;

  iFrameUrl: SafeResourceUrl;
  
  ngOnInit(): void {
    this._seoService.setTitle('Liste Eventi');
    this.serviceSubscription = this._projectService.getServiceKey().subscribe(e => {
      const loadingItem: LoadingItem = {id: 'liste-eventi-config', message: 'Stiamo recuperando la configurazione delle liste eventi...'};
      this._loadingService.addLoad(loadingItem);
      this._projectService.getAgencyNetwork().toPromise().then(
        (agencyNetworkResolved) => {
            let urlListeEventi = '';
            if (agencyNetworkResolved && (Number(agencyNetworkResolved.id_network) === Networks.GEO)) {
                urlListeEventi = `${environment.geoListeInViaggioUrl}/accedi/iframe?agenzia_id=${encodeURIComponent(agencyNetworkResolved.id_network_agency)}`;
            } else {
                urlListeEventi = `${environment.wtgListeInViaggioUrl}?codAgency=${encodeURIComponent(agencyNetworkResolved.id_network_agency)}`;
            }
          if (agencyNetworkResolved?.id_network) {
            urlListeEventi += `&network=${encodeURIComponent(agencyNetworkResolved.id_network)}`;
          }
          this.iFrameUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlListeEventi);
        },
        (agencyNetworkRejected) => console.error(agencyNetworkRejected),
      ).finally(() => this._loadingService.removeLoad(loadingItem));
    });
  }

}
